var SupportV2SelectDifferentOrderMenuView, SupportVerticalSelectDifferentOrderMenuView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV2SelectDifferentOrderMenuView = require('./v2_select_different_order_menu_view');

SupportVerticalSelectDifferentOrderMenuView = (function(superClass) {
  extend(SupportVerticalSelectDifferentOrderMenuView, superClass);

  function SupportVerticalSelectDifferentOrderMenuView() {
    return SupportVerticalSelectDifferentOrderMenuView.__super__.constructor.apply(this, arguments);
  }

  SupportVerticalSelectDifferentOrderMenuView.prototype.toDetailHash = function() {
    var hash;
    hash = SupportV2SelectDifferentOrderMenuView.prototype.toDetailHash.call(this);
    hash.showVerticalView = true;
    return hash;
  };

  return SupportVerticalSelectDifferentOrderMenuView;

})(SupportV2SelectDifferentOrderMenuView);

module.exports = SupportVerticalSelectDifferentOrderMenuView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC92ZXJ0aWNhbF9zZWxlY3RfZGlmZmVyZW50X29yZGVyX21lbnVfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9vcmRlcl9yZWxhdGVkL3ZlcnRpY2FsX3NlbGVjdF9kaWZmZXJlbnRfb3JkZXJfbWVudV92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLGtGQUFBO0VBQUE7OztBQUFBLHFDQUFBLEdBQXdDLE9BQUEsQ0FBUSx1Q0FBUjs7QUFFbEM7Ozs7Ozs7d0RBR0osWUFBQSxHQUFjLFNBQUE7QUFDWixRQUFBO0lBQUEsSUFBQSxHQUFPLHFDQUFxQyxDQUFBLFNBQUUsQ0FBQSxZQUFZLENBQUMsSUFBcEQsQ0FBeUQsSUFBekQ7SUFDUCxJQUFJLENBQUMsZ0JBQUwsR0FBd0I7V0FDeEI7RUFIWTs7OztHQUgwQzs7QUFRMUQsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
